<template>
  <div v-if="isLoaded" class="popUpWrap">
    <section class="popup dark assessment guide">
      <div class="topArea">
        <div class="exit" @click.stop="onClickClose"></div>
      </div>
      <div class="scrollY">
        <div v-if="isAgreeToRulesPopup" class="textArea">
          <h5>{{ t("challenges-agree-rules-title") }}</h5>
        </div>
        <ul class="guideWrap flex">
          <li>
            <div class="leftArea"><h3>{{ getTitle }}</h3></div>
            <div class="scrollY">
              <LazyGuideline :is-contest="isContest" />
            </div>
          </li>
          <li v-if="isActiveAntiCheating" class="h-on">
            <div class="leftArea"><h3 class="red">{{ t("challenges-anti-cheating-guidance") }}</h3></div>
            <div class="scrollY">
              <LazyAntiCheatingGuidance :contest-info="contestInfo" :is-proctive="isProctive" />
            </div>
          </li>
        </ul>
        <LazyAgreeToRules v-if="isAgreeToRulesPopup" />
      </div>
    </section>
  </div>
</template>

<script setup lang="ts">
import {ref, useI18n} from "#imports";
import { computed } from "vue";
import {useLearningAssessmentStore} from "~/store/learning/assessment/learningAssessmentStore";
import {useDialogStore} from "~/store/dialog/dialogStore";
import {ContestListModel} from "~~/package/mapper/contest/model/ContestListModel";
import {
  ProSkillAssureAssessmentMyInfoModel
} from "~~/package/mapper/proSkillAssure/model/assessment/myInfo/ProSkillAssureAssessmentMyInfoModel";

const { t } = useI18n();

const dialogStore = useDialogStore();
const assessmentStore = useLearningAssessmentStore();

const contestInfo = ref<ContestListModel>(dialogStore.options?.props?.contest ?? new ContestListModel);
const assessmentInfo = ref<ProSkillAssureAssessmentMyInfoModel>(dialogStore.options.props.assessmentInfo ?? new ProSkillAssureAssessmentMyInfoModel());

const isAgreeToRulesPopup = ref(dialogStore.options?.props?.isAgreeToRules ?? false);

const getTitle = computed(() =>
  isContest.value ? t("challenges-guidelines") : t("skillCertify-assessment-guidelines")
)

const isContest = computed(() =>
    contestInfo.value.id !== 1
)

const isActiveAntiCheating = computed(() => {
  if (isContest.value)
    return contestInfo.value.useTabSwitchProctor ||
        contestInfo.value.useMultiMonitorProctor ||
        contestInfo.value.useCopyPasteProctor ||
        contestInfo.value.useShortcutProctor
  else return assessmentStore.proctoringConfig.useTabSwitchProctor ||
      assessmentStore.proctoringConfig.useMultiMonitorProctor ||
      assessmentStore.proctoringConfig.useCopyPasteProctor ||
      assessmentStore.proctoringConfig.useShortcutProctor
})

const isProctive = computed(() => {
  if(isContest.value) return false;
  return assessmentInfo.value.useExternalMonitoringFlag
});

const onClickClose = () => {
  dialogStore.close();
}

const isLoaded = ref(false);

onMounted(() => {
  isLoaded.value = true;
})
</script>

<style>
@import "assets/scss/popup_style.scss";
</style>
